import { NgModule } from '@angular/core';

// Composants graphiques utilises

// Module metier utilises

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers

// Services metier
import { TypeMaintenanceService } from './services/type-maintenance.service';

// Pipes

@NgModule({
	imports: [
	],
	providers: [
		TypeMaintenanceService,
	],
	declarations: [
	],
	exports: [
	]
})
export class TypeMainenanceModule {
	constructor() { }
}